<div container classes="container">
  <div
    class="references__accordion position-relative z-0 d-flex flex-column gap-3"
    ngbAccordion
    #accordions="ngbAccordion"
  >
    <div ngbAccordionItem="references-item" [destroyOnHide]="false">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton id="references-toggle">
          <h3 class="mb-0 text-dark">About the Survey</h3>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="references-content text-dark">
              <p>
                This survey was fielded by <a href="https://www.ipsos.com/en-us" class="text-primary text-decoration-underline" target="_blank" rel="noopener" (click)="navigateTo('https://www.ipsos.com/en-us', $event)">Ipsos</a> (www.ipsos.com) as an online,
                15-minute, self-administered survey among U.S. adults who are at
                risk of developing type 1 diabetes and caregivers to children
                under age 18 who are at risk of developing type 1 diabetes
                between April 1 and May 1, 2026. The national sample included
                1,000 U.S. adults and caregivers who met survey qualification
                criteria. Additional augmented interviews were conducted in six
                key markets – TX, GA, CA, FL, MA, and NY – to achieve a base
                size of n=150 each, including a mix of at-risk adults and
                caregivers. Respondents were recruited from opt-in panels of
                general population respondents across the country.
              </p>
              <p>
                To participate as an at-risk adult, respondents had to be ages
                18-45 and have a first-degree family member (e.g., a parent,
                child, or sibling) diagnosed with T1D. To participate as a
                caregiver, respondents had to be ages 18-60 and be the parent or
                caregiver of a child who has a first-degree family member
                diagnosed with T1D. Potential respondents were excluded if they
                were unwilling to provide informed consent, were not the primary
                decision maker for their healthcare decisions or if they/their
                child had previously taken an autoantibody blood test for T1 D.
                The final sample size for the survey is 1,511, including 511
                respondents for the state-level augments, which are not included
                in the national findings. No weights were applied to either
                sample, and findings reflect the opinions of these respondents
                only.
              </p>
              <p>This survey was commissioned by Sanofi.</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
